module.exports = __webpack_public_path__ + "static/accr-mbawa-39db8f31f1f7bed60077346ebfdc74c2.svg";